import { render, staticRenderFns } from "./pruebasCourse.vue?vue&type=template&id=2ccc7c8c&scoped=true"
import script from "./pruebasCourse.vue?vue&type=script&lang=js"
export * from "./pruebasCourse.vue?vue&type=script&lang=js"
import style0 from "./pruebasCourse.vue?vue&type=style&index=0&id=2ccc7c8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccc7c8c",
  null
  
)

export default component.exports